module.exports = __webpack_public_path__ + "img/beachUmbrellaWithCover.c0706ffc.svg";